import { Checkbox } from '@metrika/ui-kit/carbon';
import { useCallback } from 'react';
import { useFlags, useSetFlag } from '../../_env';
import { DebugMainPanelWrapper } from './styles';

export function DebugMainPanel() {
   const flags = useFlags();
   const setFlag = useSetFlag();

   const FlagCheckbox = useCallback(
      ({
         id,
         labelText,
         reset,
         reload,
         syncOn,
         className,
         onlyLocal,
      }: {
         onlyLocal?: boolean;
         className?: string;
         id: keyof typeof flags;
         labelText: string;
         reload?: boolean;
         reset?: (keyof typeof flags)[];
         syncOn?: (keyof typeof flags)[];
      }) =>
         onlyLocal && window.location.hostname !== 'localhost' ? null : (
            <div>
               <Checkbox
                  id={id}
                  className={className}
                  labelText={labelText}
                  checked={flags[id]}
                  onChange={() => {
                     const f = flags[id];
                     setFlag(id, !f);
                     if (!f && reset) {
                        reset.forEach((ff) => setFlag(ff, false));
                     }
                     if (!f && syncOn) {
                        syncOn.forEach((ff) => setFlag(ff, true));
                     }
                     if (reload) {
                        setFlag('debugPersist', true);
                        window.location.reload();
                     }
                  }}
               />
            </div>
         ),
      [flags, setFlag],
   );

   if (!(flags.debugEnabled && flags.debugShow)) return null;

   return (
      <DebugMainPanelWrapper>
         <p>Flags</p>
         <FlagCheckbox id={'debugPersist'} labelText={'persist'} className={'debugPersist'} />
         <p>Global</p>
         <FlagCheckbox id={'apiDelay'} labelText={'apiDelay'} />
         <FlagCheckbox id={'forceStandard'} labelText={'forceStandardUser'} reload />
         <FlagCheckbox id={'forceSingleOrg'} labelText={'forceSingleOrg'} reload />
         <FlagCheckbox id={'forceUserNotDeletable'} labelText={'forceUserNotDeletable'} reload />
         <p>Dashboards</p>
         <FlagCheckbox id={'debugShowTilePanel'} labelText={'showTileDebug'} />
         <FlagCheckbox id={'chartingServiceGridEditor'} labelText={'showGridEditor'} />
         <FlagCheckbox id={'useCsDebugApi'} labelText={'useCsDebugApi'} reload />
         <FlagCheckbox id={'useCsAesQuery'} labelText={'useCsAesQuery'} reload />
         <FlagCheckbox id={'useDots'} labelText={'useDots'} />
         {/* <FlagCheckbox id={'useDraftData'} labelText={'useDraftData'} reload />*/}
         <p>Debug</p>
         <FlagCheckbox id={'debugLayout'} labelText={'showLayoutOutlines'} reload />
         <FlagCheckbox id={'debugDevTools'} labelText={'enableRecoilDevTools'} reload />
         <FlagCheckbox id={'debugDevToolsRedux'} labelText={'enableReduxDevTools'} reload />
         <p>V3 Features</p>
         <FlagCheckbox id={'showV3Features'} labelText={'showV3Features'} />
         <p>Risk</p>
         <FlagCheckbox id={'showScoringTab'} labelText={'showScoringTab'} />
         {window.location.hostname === 'localhost' && <p>Localhost Only</p>}
      </DebugMainPanelWrapper>
   );
}
